export default {
	tabs: {
		attendanceType: 'نظام الدوام',
		personalInformation: 'المعلومات الشخصية',
		penaltiesAndRewardsType: 'العقوبات والمكافئات',
		jobPosition: 'المسميات الوظيفية',
		salaries: 'الرواتب',
		'reminders-types': 'التذكيرات',
		AllowanceType: 'البدلات',
		vacationType: 'أنواع الأجازات',
		PermissionsTypes: 'أنواع الأذونات',
		MissionsTypes: 'أنواع المهام',
		jobPlace: 'مكان العمل',
		AddLanguages: 'لغة',
		AddComputerSkills: 'مهارات حاسوب',
		AddDetailsType: 'تفاصيل'
	},
};
